
import { Link } from "react-router-dom"

export default function Team1() {
	return (
		<>

			<div className="tf-widget-team main-content">
				<div className="themeflat-container">
					<div className="team-member">
						<div className="title-box title-small center-title-box">
							<span className="sub-title wow fadeInUp animated">Ekipa</span>
							<h2 className="title-section wow fadeInUp animated">Hetsika fandriana milay</h2>
						</div>
						<div className="row team">
							<div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
								<div className="team-item wow fadeInUp animated " data-wow-delay="0.1s">
									<div className="team-image">
										<img src="images/member/team1.jpg" alt="Team member" />
										<div className="team-social">
											<ul>
												<li>
													<Link to="/facebook.com"><i className="icon-facebook" /></Link>
												</li>
												<li>
													<Link to="/twitter.com"><i className="icon-twitter" /></Link>
												</li>
												<li>
													<Link to="/youtube.com"><i className="icon-youtube" /></Link>
												</li>
											</ul>
										</div>
										<div className="shape-team" />
									</div>
									<h3 className="name-member">XXXXXXX</h3>
									<h4 className="job">Mpandresy</h4>
								</div>
							</div>
							<div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
								<div className="team-item wow fadeInUp animated " data-wow-delay="0.3s">
									<div className="team-image">
										<img src="images/member/team2.jpg" alt="Team member" />
										<div className="team-social">
											<ul>
												<li>
													<Link to="/facebook.com"><i className="icon-facebook" /></Link>
												</li>
												<li>
													<Link to="/twitter.com"><i className="icon-twitter" /></Link>
												</li>
												<li>
													<Link to="/youtube.com"><i className="icon-youtube" /></Link>
												</li>
											</ul>
										</div>
										<div className="shape-team" />
									</div>
									<h3 className="name-member">BBBBBB</h3>
									<h4 className="job">Manager</h4>
								</div>
							</div>
							<div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
								<div className="team-item wow fadeInUp animated " data-wow-delay="0.5s">
									<div className="team-image">
										<img src="images/member/team3.jpg" alt="Team member" />
										<div className="team-social">
											<ul>
												<li>
													<Link to="/facebook.com"><i className="icon-facebook" /></Link>
												</li>
												<li>
													<Link to="/twitter.com"><i className="icon-twitter" /></Link>
												</li>
												<li>
													<Link to="/youtube.com"><i className="icon-youtube" /></Link>
												</li>
											</ul>
										</div>
										<div className="shape-team" />
									</div>
									<h3 className="name-member">CCCCC</h3>
									<h4 className="job">Sokajy vehivavy</h4>
								</div>
							</div>
							<div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
								<div className="team-item wow fadeInUp animated " data-wow-delay="0.7s">
									<div className="team-image">
										<img src="images/member/team4.jpg" alt="Team member" />
										<div className="team-social">
											<ul>
												<li>
													<Link to="/facebook.com"><i className="icon-facebook" /></Link>
												</li>
												<li>
													<Link to="/twitter.com"><i className="icon-twitter" /></Link>
												</li>
												<li>
													<Link to="/youtube.com"><i className="icon-youtube" /></Link>
												</li>
											</ul>
										</div>
										<div className="shape-team" />
									</div>
									<h3 className="name-member">DDDDDD</h3>
									<h4 className="job">Sokajy senior</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
